/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import * as React from 'react';

interface IFileUploadProps {
  id: string,
  accept: string[],
  callback: Function,
  callbackkey: string,
  children?: React.ReactNode
}

const FileUpload = React.forwardRef<HTMLInputElement, IFileUploadProps>((props: IFileUploadProps, ref) => {
  return <>
      <input ref={ref} type="file" id={props.id} onChange={() => props.callback(props.callbackkey)} accept={props.accept.join(',')} hidden/>
      <label className="btn btn-primary btn-inline" htmlFor={props.id}>
          { props.children }
      </label>
    </>;
}
);

FileUpload.displayName = 'FileUpload';
export default FileUpload;
